import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [branding, setBranding] = useState(null);
  const [accessToken, setAccessToken] = useState(localStorage.getItem("access_token"));
  const [adminToken, setAdminToken] = useState(localStorage.getItem("admin_token"));
  const [userToken, setUserToken] = useState(localStorage.getItem("user_token"));
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/public/branding").then((r) => setBranding(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (userToken) {
      api.get("/user/me").then((r) => setUser(r.data)).catch(() => {
        localStorage.removeItem("user_token"); setUserToken(null); setUser(null);
      });
    }
  }, [userToken]);

  const grantAccess = (t) => { localStorage.setItem("access_token", t); setAccessToken(t); };
  const loginAdmin = (t) => { localStorage.setItem("admin_token", t); setAdminToken(t); };
  const logoutAdmin = () => { localStorage.removeItem("admin_token"); setAdminToken(null); };
  const exitAccess = () => { localStorage.removeItem("access_token"); setAccessToken(null); };
  const loginUser = (t, u) => { localStorage.setItem("user_token", t); setUserToken(t); setUser(u); };
  const logoutUser = () => { localStorage.removeItem("user_token"); setUserToken(null); setUser(null); };

  return (
    <AppContext.Provider value={{ branding, accessToken, adminToken, userToken, user, setUser, grantAccess, loginAdmin, logoutAdmin, exitAccess, loginUser, logoutUser }}>
      {children}
    </AppContext.Provider>
  );
}
